// Voysi flamingo Badge primitive.
// Port of voysi-shell.jsx::VBadge — tones map to the design system's
// semantic + flamingo palette. Use `pulse` for live indicators.

import type { ReactNode } from 'react'

export type BadgeTone =
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'flamingo'
  | 'neutral'
  | 'ink'

interface BadgeProps {
  tone?: BadgeTone
  pulse?: boolean
  children: ReactNode
  className?: string
}

const TONES: Record<BadgeTone, { bg: string; fg: string; dot: string }> = {
  success: { bg: 'rgba(29,185,84,0.12)', fg: '#0A7A36', dot: '#1DB954' },
  warning: { bg: 'rgba(244,180,0,0.16)', fg: '#8A6500', dot: '#F4B400' },
  danger: { bg: 'rgba(229,72,77,0.10)', fg: '#A8272C', dot: '#E5484D' },
  info: { bg: 'rgba(91,141,239,0.12)', fg: '#274BA8', dot: '#5B8DEF' },
  flamingo: { bg: '#FFF1F6', fg: '#C4125C', dot: '#FF3D84' },
  neutral: { bg: '#F3F2EF', fg: '#49474A', dot: '#9E9C96' },
  ink: { bg: '#0E0D11', fg: '#FFFFFF', dot: '#FF3D84' },
}

export function Badge({ tone = 'neutral', pulse = false, children, className }: BadgeProps) {
  const t = TONES[tone]
  return (
    <span
      className={
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-[3px] text-[11.5px] font-semibold' +
        (className ? ` ${className}` : '')
      }
      style={{ background: t.bg, color: t.fg }}
    >
      <span
        className="h-1.5 w-1.5 rounded-full"
        style={{
          background: t.dot,
          animation: pulse ? 'voysiPulse 1.4s infinite' : undefined,
        }}
      />
      {children}
    </span>
  )
}
